import React, {Component} from 'react'
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog'
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions'
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent'
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import ui from 'redux-ui';
import {connect} from 'react-redux';

export const BETA_LIST_DIALOG = 'BETA_LIST_DIALOG';
const defaultContent = "You’re information has been submitted to our team for review. We will be reaching out to get the necessary details soon. Please hold tight!"

@ui({
    state: {
        open: false,
    },
    reducer: (state, action) => {
        switch (action.type) {
            case BETA_LIST_DIALOG:
                return state.set('open', action.status);
        }
        return state;
    }
})
@connect(
    state => {
        return {}
    },
    dispatch => ({
        onClose: () => {
            dispatch({type: BETA_LIST_DIALOG, status: false})
        }
    })
)

export default class BetaListDialog extends Component {

    render() {
        const actions = [];

        const listType = this.props.type || 'beta list'

        return (
            <Dialog
                key="1"
                actions={actions}
                // modal={false}
                open={this.props.ui.open}
                onClose={() => {
                    this.props.onClose();
                }}
            >
                <DialogTitle>
                    Congratulations, you’ve been added to the {listType}
                </DialogTitle>
                <DialogContent>
                    {this.props.content ? this.props.content : defaultContent}
                </DialogContent>
                <DialogActions>
                    <Button
                        color='primary'
                        onClick={() => {
                            this.props.onClose();
                        }}
                    >
                        Got it
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }


}
